import React from 'react';
import { Offcanvas, Button, Form, Card, Row, Col, Image, Spinner } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

function OffcanvasUpdateFAQ({ show, onHide, selectedRow, onSubmit, isLoadingButton }) {
    const { t } = useTranslation();

    return (
        <Offcanvas show={show} onHide={onHide} placement="end">
            <Offcanvas.Header closeButton>
                <Offcanvas.Title><h2>{t('Update FAQ')}</h2></Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body>
                {/* Form */}
                <Form onSubmit={onSubmit}>
                    <Card className="mb-4">
                        <Card.Header className="card-header-height d-flex justify-content-between align-items-center">
                            <h4 className="mb-0">{t('Frequently-Asked-Question')}</h4>
                        </Card.Header>
                        <Card.Body className="">
                            <Row className="mb-4 d-none">
                                <Col lg={12} md={12} className="mb-0">
                                    {/* FAQ Question */}
                                    <Form.Group className="mb-3">
                                        <Form.Label htmlFor="id">{t('ID')}</Form.Label>
                                        <Form.Control
                                            type="text"
                                            id="id"
                                            defaultValue={selectedRow ? selectedRow.id : ''}
                                            readOnly
                                            required
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row className="mb-4">
                                <Col lg={12} md={12} className="mb-0">
                                    {/* FAQ Question */}
                                    <Form.Group className="mb-3">
                                        <Form.Label htmlFor="title">{t('Question')}</Form.Label>
                                        <Form.Control
                                            as="textarea"
                                            rows={2}
                                            id="title"
                                            placeholder={t('Enter FAQ Question')}
                                            defaultValue={selectedRow ? selectedRow.faq_title : ''}
                                            required
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row className="mb-4">
                                <Col lg={12} md={12} className="mb-0">
                                    {/* FAQ Answer */}
                                    <Form.Group className="mb-3">
                                        <Form.Label htmlFor="content">{t('Answer')}</Form.Label>
                                        <Form.Control
                                            as="textarea"
                                            rows={10}
                                            id="content"
                                            placeholder={t('Enter FAQ Answer')}
                                            defaultValue={selectedRow ? selectedRow.faq_content : ''}
                                            required
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card>
                    <Card className="mb-4">
                        <Card.Header className="card-header-height d-flex justify-content-between align-items-center">
                            <h4 className="mb-0">{t('Categories')}</h4>
                        </Card.Header>
                        <Card.Body className="">
                            <Row className="mb-4">
                                <Col lg={12} md={12} className="mb-0">
                                    { /* FAQ Categories */}
                                    <Form.Group className="mb-3">
                                        <Form.Label htmlFor="categories">{t('FAQ Categories')}</Form.Label>
                                        <Form.Control
                                            type="text"
                                            id="categories"
                                            placeholder={t('Enter FAQ Categories')}
                                            defaultValue={selectedRow ? selectedRow.faq_categories : ''}
                                            onBlur={(e) => {
                                                const formattedValue = e.target.value.toLowerCase().replace(/\s+/g, '');
                                                e.target.value = formattedValue;
                                            }}
                                            required
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card>
                    <div className="d-flex justify-content-end mt-4">
                        <Button variant="secondary" onClick={onHide}>
                            {t('Cancel')}
                        </Button>
                        <Button className="ms-2 d-end" variant="primary" type="submit" disabled={isLoadingButton}>
                            {isLoadingButton ? (
                                <>
                                    <Spinner animation="border" size="sm" className="me-2" />
                                    {t('Update FAQ')}
                                </>
                            ) : (
                                t('Update FAQ')
                            )}
                        </Button>
                    </div>

                </Form>
            </Offcanvas.Body>
        </Offcanvas>
    );
}

export default OffcanvasUpdateFAQ;